

exports.__esModule = true;

var _angular = require('angular');

var _index = require('squid/index');

var _index2 = require('xo-models/src/checkout/index');

var _index3 = require('xo-models/src/user/index');

require('xo-ui-components/src/dropdown/directive');

require('xo-ui-components/src/error-tooltip/directive');

require('xo-address-components/src/add-address/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Component.extend('xoTravelRule', {
    tag: 'xo-travel-rule',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            optional: false
        },
        finish: {
            type: 'var',
            optional: false
        }
    },

    resolve: {
        models: function models() {
            return {
                checkoutSession: _index2.$CheckoutSessionModel.instance(this.token).retrieve()
            };
        }
    },

    actions: {
        submit: function submit() {
            var data = {};

            if (this.needPayerGovtId) {
                var chosenIdDetails = this.idTypes.filter(function (obj) {
                    return obj.name === this.idData.type;
                })[0];

                // Scrub the formatting when invoking the backend services.
                var unformatted = (this.idData.value || '').replace(/[^0-9a-zA-Z]+/g, '');

                data.newDocId = {
                    type: chosenIdDetails.idType,
                    subType: chosenIdDetails.idSubtype,
                    issuerCountry: this.idData.country,
                    issuer: chosenIdDetails.idIssuer,
                    value: unformatted,
                    collectionPoint: 'UNKNOWN',
                    placeOfIssue: this.idData.country
                };
            }

            if (this.needPayerAddress) {
                var address = this.address;
                data.newAddress = {
                    address1: address.line1,
                    address2: address.line2,
                    city: address.city,
                    state: address.state,
                    zip: address.postal_code,
                    iso_country: 'US'
                };
            }

            this.userInfo.action('addGovtIdAddress', {
                data: data,

                success: function success() {
                    var checkoutSession = _index2.$CheckoutSessionModel.instance(this.token);
                    var checkoutCart = _index2.$CheckoutCartModel.instance(this.token);
                    return checkoutSession.action('create', {
                        data: {
                            baToken: checkoutCart.billing && checkoutCart.billing.ba_token
                        },
                        success: function success() {
                            // Clear the errors if create checkout session was successful
                            this.checkoutSession.errorData = undefined;
                            this.finish();
                        }
                    });
                },
                validation: function validation(validationData) {
                    var $el = $(_angular.$element);
                    var $field = $($el.find('[name="' + validationData.field + '"]'));
                    $field.addClass('backendError');
                    $field.attr('aria-invalid', true);
                    $field.focus();
                }
            });
        }
    },

    lifecycle: {
        populate: function populate() {
            var country = _index.$locale.getCountryCodeISO(),
                countries = _index.$locale.content.get('countryList', {}),
                countryList = [];
            this.country = country;
            this.address = { country: country };
            this.locale = _index.$locale;
            this.metadata = _index.$locale.metadata;
            (0, _angular.$forEach)(Object.keys(countries), function (countryCode) {
                countryList.push({
                    key: countryCode,
                    value: countries[countryCode]
                });
            });
            countryList.sort(function (a, b) {
                return a.value.localeCompare(b.value);
            });
            this.countryList = countryList;

            this.idTypes = [{ name: 'SSN', value: _index.$locale.content.travelRule.ssnDropdownLabel, idType: 'TAX_ID', idSubtype: 'SSN', idIssuer: 'US_SSN' }, { name: 'TaxID', value: _index.$locale.content.travelRule.taxIdDropdownLabel, idType: 'TAX_ID', idSubtype: 'ITIN', idIssuer: 'US_ITIN' }, { name: 'EmployerID', value: _index.$locale.content.travelRule.employerIdDropdownLabel, idType: 'TAX_ID', idSubtype: 'TIN', idIssuer: 'US_TIN' }, { name: 'Passport', value: _index.$locale.content.travelRule.passportDropdownLabel, idType: 'PASSPORT', idIssuer: 'PASSPORT' }, { name: 'AlienNumber', value: _index.$locale.content.travelRule.aNumberDropdownLabel, idType: 'IMMGT_ID', idIssuer: 'IMMIGRATION' }];
            this.idData = {
                'type': 'SSN',
                'value': '',
                'country': 'US'
            };
            this.idTypeChanged = function () {
                this.idData.country = 'US';
            };

            var payerDetailsTypes = this.checkoutSession.get('errorData.resolution.data', []);
            if (payerDetailsTypes.indexOf('GOVERNMENT_ID') > -1) {
                this.needPayerGovtId = true;
            }
            if (payerDetailsTypes.indexOf('STREET_ADDRESS') > -1) {
                this.needPayerAddress = true;
            }

            this.userInfo = _index3.$UserInfoModel.instance(this.token);
        }
    }
});


_angular.$forEach;

_angular.$element;

_index.$Component;

_index.$locale;

_index2.$CheckoutSessionModel;

_index2.$CheckoutCartModel;

_index3.$UserInfoModel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-form-components/src/travel-rule/directive.js
// module id = ./components/xo-form-components/src/travel-rule/directive.js
// module chunks = 1